export { useCookieConsent } from './use-cookie-consent'
